import React from 'react';
import './HomePage.css';
import HeroSection from 'sections/HeroSection';
import ServicesSection from 'sections/ServicesSection';
import TestimonialsSection from 'sections/TestimonialsSection';
import ServiceAreaSection from 'sections/ServiceAreaSection';
import CallToAction from 'components/CallToAction/CallToAction';
import { Helmet } from 'react-helmet-async';

const HomePage: React.FC = () => {
	return (
		<>
			<Helmet>
				<title>The G.O.A.T. Grazers | Eco-Friendly Goat Grazing in East Tennessee</title>
				<meta name="description" content="Eco-friendly land clearing, invasive plant removal, and fire prevention using goats in Knoxville and East Tennessee." />
			</Helmet>
			<HeroSection />
			<ServicesSection />
			{/* <TestimonialsSection /> */}
			<ServiceAreaSection />
			<div className="home-cta-wrapper">
				<div className="container">
					<CallToAction
						title="Ready to let our herd get to work?"
						subtitle="Get a free, no-obligation estimate for your property today!"
						buttonText="Get Your Free Estimate"
					/>
				</div>
			</div>
		</>
	);
};

export default HomePage;


